import React from "react";
import { useEventDataOfSelectedEvent } from "@Utils";
import { isInstallmentsPlanType } from "repoV2/utils/common/listing";
import { SidebarSectionDivider } from "../SidebarSectionDivider";
import commonStyles from "../commonStyles.module.scss";
import { IEarlyBird } from "./IEarlyBird";
import styles from "./earlyBird.module.scss";
import useEarlyBird from "./utils/useEarlyBird";

const EarlyBird = (props: IEarlyBird.IProps): JSX.Element | null => {
    const { isMobile } = props;
    const {
        eventData: { payment_plan_type },
    } = useEventDataOfSelectedEvent();

    const {
        earlyBirdText,
        earlyBirdDiscountString,
        earlyBirdClockTimerString,
        hideComponent,
    } = useEarlyBird(props);

    if (hideComponent || isInstallmentsPlanType(payment_plan_type)) return null;

    return isMobile ? (
        <div className={styles.earlyBirdStrip}>
            <span className={styles.earlyBirdStripText}>{earlyBirdText}</span>
            <span className={styles.earlyBirdStripPrice}>
                {earlyBirdDiscountString}
            </span>
        </div>
    ) : (
        <>
            <div className={commonStyles.sidebarSectionTitle}>
                {earlyBirdText}
            </div>
            <div className={styles.container}>
                <div className={styles.earlyBirdText}>
                    {earlyBirdDiscountString}
                </div>
                <div className={styles.earlyBirdText} suppressHydrationWarning>
                    {`Expiring in ${earlyBirdClockTimerString}`}
                </div>
            </div>
            <SidebarSectionDivider />
        </>
    );
};
export default EarlyBird;
